import React from 'react';

import Box from '@material-ui/core/Box';
import FormHelperText from '@material-ui/core/FormHelperText';

import { warnTextColor } from '../../../lib/theme';
import { IFieldTokenMessage } from './compose-panel.validation';

interface IFieldTokenIssuesProps {
  // Per-tier issue messages for one content field (undefined/empty = clean).
  issues?: IFieldTokenMessage[];
}

// Always-visible warnings beneath a content field explaining its highlighted
// invalid tokens: red (error prop) for blocking errors, burnt-orange for the
// needs-a-default warning. The aria-live region stays mounted for announcements.
export const FieldTokenIssues: React.FC<IFieldTokenIssuesProps> = ({ issues }) => (
  <Box aria-live="polite">
    {(issues || []).map((issue, index) => (
      <FormHelperText
        key={index}
        error={issue.tone === 'danger'}
        style={issue.tone === 'warn' ? { color: warnTextColor } : undefined}
      >
        {issue.text}
      </FormHelperText>
    ))}
  </Box>
);
